exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\n.grid-tile-overlay {\n    -webkit-transition: .5s ease;\n    -o-transition: .5s ease;\n    transition: .5s ease;\n    opacity: 0;\n}\n\n.grid-tile-elt:hover .grid-tile-overlay {\n    opacity: 1;\n}\n\n.image-gallery-image img {\n    -o-object-fit: contain;\n       object-fit: contain;\n    height: 500px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/resources/css/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss"}!./src/resources/css/index.css
// module chunks = 0